
import React, { useState } from 'react';
import { RegistrationData } from './types';
import AccountInformationStep from './AccountInformationStep';
import PersonalDetailsStep from './PersonalDetailsStep';
import MovementDetailsStep from './MovementDetailsStep';
import ProfileReviewStep from './ProfileReviewStep';

const MultiStepRegistrationForm: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [formData, setFormData] = useState<RegistrationData>({
    // Screen 1: Account Information
    fullName: '',
    username: '',
    phoneNumber: '',
    email: '',
    password: '',
    confirmPassword: '',
    
    // Screen 2: Personal Details
    gender: '',
    dateOfBirth: null,
    state: '',
    localGovernment: '',
    ward: '',
    
    // Screen 3: Movement Details
    occupation: '',
    association: '',
    referralCode: ''
  });

  const handleDataChange = (data: Partial<RegistrationData>) => {
    setFormData(prev => ({ ...prev, ...data }));
    // Clear errors for fields being updated
    const updatedErrors = { ...errors };
    Object.keys(data).forEach(key => {
      delete updatedErrors[key];
    });
    setErrors(updatedErrors);
  };

  const handleNext = () => {
    setCurrentStep(prev => prev + 1);
    setErrors({});
  };

  const handlePrevious = () => {
    setCurrentStep(prev => prev - 1);
    setErrors({});
  };

  const renderStep = () => {
    const stepProps = {
      data: formData,
      onDataChange: handleDataChange,
      onNext: handleNext,
      onPrevious: currentStep > 1 ? handlePrevious : undefined,
      errors
    };

    switch (currentStep) {
      case 1:
        return <AccountInformationStep {...stepProps} />;
      case 2:
        return <PersonalDetailsStep {...stepProps} />;
      case 3:
        return <MovementDetailsStep {...stepProps} />;
      case 4:
        return <ProfileReviewStep {...stepProps} />;
      default:
        return <AccountInformationStep {...stepProps} />;
    }
  };

  return (
    <div className="w-full">
      {renderStep()}
    </div>
  );
};

export default MultiStepRegistrationForm;
